'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatTextPassage } from 'blocks-nextjs/blocks-react/components/TextPassage';
import { CatTooltip } from 'blocks-nextjs/blocks-react/components/Tooltip';
import { CatDrawer } from 'blocks-nextjs/blocks-react/components/Drawer';
import styles from './reman-pop-up.module.scss';

const RemanPopUp = ({ isMobile = false }: { isMobile?: boolean }) => {
  const t = useTranslations();
  const [drawerActive, setDrawerActive] = useState(false);

  const handleCloseDrawer = () => {
    setDrawerActive(false);
  };

  return isMobile ? (
    <>
      <CatButton
        variant="inline"
        onClick={() => {
          setDrawerActive(true);
        }}
      >
        {t('CAT_R_REMAN')}
      </CatButton>
      <CatDrawer
        isActive={drawerActive}
        data-testid="reman-drawer"
        onBlDrawerClose={handleCloseDrawer}
        orientation="bottom"
        className={styles['reman-drawer__header']}
        verticalMaxHeight="large"
      >
        <div slot="header" className="cat-u-theme-typography-title-sm">
          {t('CAT_REMAN')}
        </div>
        <div className={styles['reman-drawer__body']}>
          <div className="cat-u-theme-typography-body">
            {t('CAT_REMAN_VAL_STMT')}
          </div>
          <div className="cat-u-theme-typography-footnote mt-4">
            {t('CAT_REMAN_VAL_STMT_1')}
          </div>
        </div>
      </CatDrawer>
    </>
  ) : (
    <CatTooltip position="top" isInteractive>
      <CatButton slot="trigger" variant="inline">
        {t('CAT_R_REMAN')}
      </CatButton>
      <CatTextPassage size="xs">
        <div className="cat-u-theme-typography-footnote">
          {t('CAT_REMAN_VAL_STMT')}
          <p className="cat-u-margin-top-sm">{t('CAT_REMAN_VAL_STMT_1')}</p>
        </div>
      </CatTextPassage>
    </CatTooltip>
  );
};

export default RemanPopUp;
